module.exports = __webpack_public_path__ + "img/advantage_2.aa8b4f9e.svg";